import SvgPortalTooltip, { type SvgPortalTooltipProps } from '@ubnt/ui-components/SvgTooltip/SvgPortalTooltip';
import { memo } from 'react';
import { useEditorStore } from '../store';

export interface LinkTooltipProps {
  description: SvgPortalTooltipProps['description'];
}

const LinkTooltipImpl = (props: LinkTooltipProps) => {
  const { description } = props;

  const showTooltip = useEditorStore((state) => state.showTooltip);
  const tooltipPosition = useEditorStore((state) => state.tooltipPosition);

  if (!showTooltip || !tooltipPosition) {
    return null;
  }

  const { x, y } = tooltipPosition;

  return <SvgPortalTooltip left={x} top={y} width={190} description={description} />;
};

export const LinkTooltip = memo(LinkTooltipImpl);
